import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
// import Swal from "sweetalert2";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import ModalInfoEst from "../components/ModalInformacion/ModalInfoEst";

class ListaRepReg extends React.Component {
  initialState = {
    option_tipo_est: Api.loadCatalogue("cat_tipo_establecimiento"),
    option_actividad: Api.loadCatalogue("cat_actividad"),
    buscarEstablecimientos: {},

    nivelUsuario: localStorage.nivel_actual,

    openModal: false,
    establecimiento: {},
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;

    this.closeModal = this.closeModal.bind(this);
  }

  mi_grid = {};
  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getEstablecimientosRegYRep",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        razon_social: {
          label: "Razón social",
          render: (me) => {
            if (me.data.razon_social === null) {
              me.innerHTML = "";
            }
          },
        },
        folio_establecimiento: {
          label: "Código DISAAN",
          render: (me) => {
            if (me.data.folio_establecimiento === null) {
              me.innerHTML = "";
            }
          },
        },
        guid: {
          label: "GUID",
          render: (me) => {
            me.innerHTML = me.data.guid.slice(-4);
          },
        },
        actividades: {
          label: "ACTIVIDADES",
          render: (me) => {
            let texto = "";
            me.data.actividades.forEach(element => {
              texto += element.actividad + ", ";
            });
            me.innerHTML = texto.slice(0, -2);
          },
        },
        /* tipo: {
          label: "Tipo establecimiento",
          render: (me) => {
            if (me.data.tipo) {
              me.innerHTML =
                "<span title='" +
                me.data.tipo +
                "'>" +
                me.data.tipo.substr(0, 100) +
                "...</span>";
            }
          },
        }, */
      },
      buttons: [
        {
          iconClass: "fa fa-list",
          btnClass: "btn bg-gradient-green",
          btnClick: (data) => {
            this.setState({
              openModal: true,
              establecimiento: data,
            });
          },
          render: (me, data) => {},
        },
      ],
    };
    this.mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "razon_social",
            label: "Razón social",
            placeHolder: "Razón social",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "folio_establecimiento",
            label: "Código DISAAN",
            placeHolder: "Código DISAAN",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "guid",
            label: "Guid",
            placeHolder: "GUID",
            cols: 2,
            value: "",
          },
        },{
          select: {
            type: "text",
            name: "actividad",
            label: "Actividad",
            cols: 3,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.option_actividad.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarEstablecimientos: busqueda.data() });
              let search = this.state.buscarEstablecimientos;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });
  }

  closeModal() {
    /*Swal.fire({
      title: "¿Seguro que quiere cerrar?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ openModal: false });
        //this.resetStates();
      }
    });*/
    this.setState({ openModal: false });
  }

  resetStates = () => {
    /** vuelve el estado su forma inicial */
    this.setState({ ...this.initialState });
  };

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/establecimientos-activos">Establecimientos activos</Link>
          </li>
        </ol>
        <h1 className="page-header">Establecimientos activos</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
        {/**MODAL INFORMACIÓN */}
        <Modal
          isOpen={this.state.openModal}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModal();
            }}
            className="text-center"
          >
            Detalles del establecimiento:{" "}
            {this.state.establecimiento.razon_social}
          </ModalHeader>
          <ModalBody>
            <form /* onSubmit={this.handleSubmit} */>
              <ModalInfoEst
                /* key={this.state.producto_id} */
                component={this}
                establecimiento={this.state.establecimiento}
              />
            </form>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <ListaRepReg auth={auth} history={history} {...props} />;
};
